import { hasPermission, isCustomerUser } from './permissions';

export function getDefaultPathForSession(session) {
  if (session && isCustomerUser(session)) {
    return '/portal';
  }

  return '/';
}

export function getForbiddenHomePath(session) {
  return getDefaultPathForSession(session);
}

export function isSafeRedirectPath(session, path) {
  if (!session || !path || typeof path !== 'string' || !path.startsWith('/')) {
    return false;
  }

  if (
    path === '/login'
    || path === '/403'
    || path === '/forgot-password'
    || path.startsWith('/reset-password')
    || path.startsWith('/accept-invitation')
  ) {
    return false;
  }

  if (isCustomerUser(session)) {
    return path === '/portal' || path.startsWith('/portal/');
  }

  if (path.startsWith('/portal')) {
    return hasPermission(session, 'system.support.view');
  }

  return true;
}

export function resolvePostLoginPath(session, fromPath) {
  if (fromPath && isSafeRedirectPath(session, fromPath)) {
    return fromPath;
  }

  return getDefaultPathForSession(session);
}
